<form [formGroup]="postActionForm">
  <div class="my-3 bg-secondary border rounded border-radius-xl">
    <div *ngIf="notificationType">
      <h4 class="m-3">{{ ('mbs-ui:rmm-custom-alerting.wizard.steps.'+ notificationType) | i18next }}</h4>
      <hr class="bg-grey-100">
    </div>

    <div class="m-3">

      <mbs-input-label [label]="'Email notifications'"
                       [boldLabel]="true">
      </mbs-input-label>
      <div class="mb-2">
        <mbs-checkbox [boldLabel]="false"
                      [label]="'Provider'"
                      formControlName="includeProvider"
                      [descriptionOutside]="false">

          <ng-template checkboxDescription>
            <div class="text-sm">{{ providerEmail }}</div>
          </ng-template>
        </mbs-checkbox>
      </div>

      <div>
        <mbs-checkbox [boldLabel]="false"
                      [label]="emailCountLabel"
                      formControlName="enableEmails"
                      [descriptionOutside]="false">

          <ng-template checkboxDescription>
            <div class="text-sm">
              <div *ngIf="postActionForm.get('emails').value?.length">{{ postActionForm.get('emails').value.join(', ')
                }}</div>
              <div *ngIf="!postActionForm.get('emails').value.length && postActionForm.get('enableEmails').value"
                   class="text-danger">
                {{'shared:validation.noEmail' | i18next}}
              </div>
              <div>
                <mbs-button [isCtrl]="true"
                            [size]="'sm'"
                            (click)="openRecipientModal()">
                  {{ 'mbs-ui:rmm-custom-alerting.wizard.secondStep.addEmails' | i18next }}
                </mbs-button>
              </div>
            </div>
          </ng-template>
        </mbs-checkbox>

      </div>
    </div>

    <hr class="bg-grey-100">

    <div class="m-3">
      <div class="mb-2">
        <div>
          <mbs-switcher formControlName="enablePush"
                        [boldLabel]="true"
                        [expandLabel]="true"
                        [label]="'mbs-ui:rmm-custom-alerting.wizard.lastStep.sendPushNewTitle' | i18next"
                        labelPosition="left">
          </mbs-switcher>

          <div>
            <div>{{ pushAdminNameList }}</div>
            <div *ngIf="!postActionForm.get('pushAdminIdList').value.length && postActionForm.get('enablePush').value"
                 class="text-danger">
              {{'shared:validation.noAdministrator' | i18next}}
            </div>
            <div>
              <mbs-button [isCtrl]="true"
                          [disabled]="!postActionForm.get('enablePush').value"
                          (click)="openPushModal()">
                {{ 'shared:buttons.select' | i18next }}
              </mbs-button>
            </div>
          </div>
        </div>
      </div>
    </div>


    <hr *ngIf="includeConnectWise"
        class="bg-grey-100">

    <div *ngIf="includeConnectWise"
         class="m-3">
      <mbs-switcher formControlName="connectWiseIntegration"
                    [boldLabel]="true"
                    [expandLabel]="true"
                    [label]="'Open ticket at ConnectWise'"
                    labelPosition="left">
      </mbs-switcher>
    </div>

    <hr *ngIf="enableScript"
        class="bg-grey-100">

    <div *ngIf="enableScript"
         class="m-3">
      <div class="font-weight-bold mb-2">{{ 'mbs-ui:rmm-custom-alerting.wizard.lastStep.startScriptIfSetOnAlert' |
        i18next }}
        <span *ngIf="!notificationType"
              class="ico ico-InfoCircle ml-1 cursor-help text-info"
              container="body"
              tooltipClass="tooltip-lg"
              placement="top-right auto"
              [ngbTooltip]="postActionsTooltip">
        </span>
      </div>
      <div *ngFor="let item of postActionScriptList; trackBy:trackByOsType"
           class="my-2">
        <mbs-profile-notification-script-utility [id]="item.id"
                                                 [loadedId]="item.scriptId"
                                                 [osType]="item.osType"
                                                 [osList]="item.osList"
                                                 [scriptId]="item.scriptId"
                                                 (onChanges)="onScriptDataChanged($event)">
        </mbs-profile-notification-script-utility>
        <div class="row">
          <div class="col-10 text-sm">{{ getScriptDescriptionByOsType(item.osType) }}</div>
        </div>
      </div>
    </div>

    <div *ngIf="enableScript"
         class="m-3">
      <mbs-button [icon]="'ico ico-PlusThin'"
                  (click)="addScript()"
                  [disabled]="this.postActionScriptList.length > 2">
        {{ 'mbs-ui:rmm-custom-alerting.wizard.addScript' | i18next }}
      </mbs-button>
    </div>

  </div>
</form>

<ng-template #adminSelectionPushModal>
  <mbs-list-select class="ph-no-capture"
                   bindSelected="id"
                   listType="table"
                   [headers]="headers"
                   [loading]="loading"
                   [keepState]="true"
                   [showHeaders]="true"
                   [showSearch]="false"
                   [filterFields]="'email'"
                   [selectedData]="selectedAdminList"
                   [keepState]="true"
                   [data]="adminList"
                   (sort)="onSort($event)"
                   (changeSelected)="changeForPushSelectedHandler($event)"
                   [maxHeight]="maxHeight">

    <ng-template mbsTableCell
                 let-admin>
      {{ admin?.email }}
    </ng-template>
  </mbs-list-select>
</ng-template>

<ng-template #specifiedEmailModal>
  <div class="mbs-form_content">
    <div class="mbs-form-group">
      <mbs-list-editor [showLabel]="false"
                       entityName="specified email"
                       [(ngModel)]="editData"
                       [validators]="[emailValidator]">
      </mbs-list-editor>
    </div>
  </div>
</ng-template>
